import { useEffect, useState } from "react";

const BASE = import.meta.env.VITE_API_BASE_URL ?? "http://localhost:5000";

interface MetaTag {
  meta_tag_id: number;
  meta_name: string | null;
  meta_property: string | null;
  meta_content: string | null;
}

interface PageSEOData {
  page_id: number;
  title: string | null;
  meta_tags: MetaTag[];
}

export function usePageSEO(slug: string): PageSEOData | null {
  const [data, setData] = useState<PageSEOData | null>(null);

  useEffect(() => {
    const normalised = slug.startsWith("/") ? slug : `/${slug}`;

    // The homepage ("/") has no admin Page record — its SEO comes from the static
    // tags in index.html — so skip the lookup that would always 404.
    if (normalised === "/") return;

    fetch(`${BASE}/api/v1/website/pages/slug${normalised}`)
      .then((r) => (r.ok ? r.json() : null))
      .then((page) => {
        if (!page) return;
        fetch(`${BASE}/api/v1/website/page_meta_tags/page/${page.page_id}`)
          .then((r) => r.json())
          .then((mt) =>
            setData({ page_id: page.page_id, title: page.title, meta_tags: mt.meta_tags ?? [] })
          )
          .catch(() => setData({ page_id: page.page_id, title: page.title, meta_tags: [] }));
      })
      .catch(() => {});
  }, [slug]);

  return data;
}
